import React from 'react';
import { injectIntl } from 'react-intl';

import classNames from 'classnames';
import range from 'lodash/range';
import PropTypes from 'prop-types';
import Star from '../../legacyCore/icons/Star';
import style from './StarRating.scss';
import { intlShape } from '../../shared/shapes';

function createStars(stars) {
  return range(stars).map((i) => (
    <Star key={i} className={style['star-rating__icon']} verticalAlign="center" />
  ));
}

const StarRating = ({ intl, className, rating, stars = 5 }) => (
  <div
    className={classNames(style['star-rating'], className)}
    title={intl.formatMessage(
      {
        id: 'StarRating.title',
        defaultMessage: '{rating, plural, one {# star} other {# stars}}',
      },
      { rating }
    )}
  >
    <div className={style['star-rating__filled']} style={{ width: `${(rating / stars) * 100}%` }}>
      {createStars(5)}
    </div>
    <div className={style['star-rating__empty']}>{createStars(5)}</div>
  </div>
);

StarRating.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number.isRequired,
  stars: PropTypes.number,
  // eslint-disable-next-line react/no-typos
  intl: intlShape,
};

export default injectIntl(StarRating);
